export const FuncJs = async (func, model) => {
    const user_agent = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/130.0.0.0 Safari/537.36';
    // const queue_api = "http://192.168.10.84:5006";
    // const file_api = "http://192.168.10.84:5004"
    // const main_api = "http://192.168.10.84:5001"

    const queue_api = "https://queue.api.158.net";
    const file_api = "https://file.api.158.net"
    const main_api = "https://main.api.158.net"


    if (_global.loaded !== true) {
        _global.db_user = new Database({ filename: path.join(data_dir, 'db', 'user.db'), autoload: true });
        _global.db_log = new Database({ filename: path.join(data_dir, 'db', 'log.db'), autoload: true });
        console.log('数据库初始化完成');
        _global.winChild = null;
        _global.pageChild = null;
        _global.accountDouyin = null;
        _global.accountDoubao = null;
        _global.accountDeepseek = null;
        _global.accountQianwen = null;
        _global.accountBaidu = null;
        _global.screenshotPath = path.join(data_dir, 'screenshot');
        _global.is_running = false;
        _global.customer = null;
        _global.showChild = false;

        fs.emptyDir(_global.screenshotPath);
        console.log('文件夹初始化完成');
        _global.loaded = true;

    }


    //数据库操作类
    class DB {
        constructor() {
            this.db_user = _global.db_user;
            this.Logger = new Logger();
        }

        //数据库操作方法
        async getAllAccounts() {
            return await this.db_user.find({}).sort({ create_time: -1 });
        }
        //取账号，轮巡
        async getAuthAccount(platform, pre_account) {
            const query = pre_account
                ? { $or: [{ auth: true, platform: platform }, { _id: pre_account?._id ?? "" }] }
                : { auth: true, platform: platform };

            let accounts = await this.db_user.find(query).sort({ auth_time: -1 })
            if (pre_account) {
                let index = accounts.findIndex(acc => acc._id === pre_account._id);
                if (index > -1 && index < accounts.length - 1) {
                    return accounts[index + 1];
                } else {
                    return accounts[0] || null;
                }
            } else if (accounts.length > 0) {
                return accounts[0];
            } else {
                return null;
            }
        }

        async addAccount(account) {
            const doc = {
                platform: account.platform,
                phone: account.phone,
                auth: account.auth || false,
                count: account.count || 0,
                auth_time: null,
                create_time: dayjs().format('YYYY-MM-DD HH:mm:ss')
            };
            var existing = await this.db_user.findOne({ platform: account.platform, phone: account.phone });
            if (existing) {
                return { success: false, message: '账号已存在' };
            } else {
                await this.db_user.insert(doc);
                return { success: true, data: doc };
            }
        }
        async layoutAccounts(account) {
            await this.db_user.update({ _id: account._id }, { $set: { auth: false } });
            await this.Logger.addLog(account.platform, `账号 ${account.phone} 授权失效`);
            return
        }

        async updateAccount(id, updates) {
            return await this.db_user.update({ _id: id }, { $set: updates });
        }

        async deleteAccount(id) {
            return await this.db_user.remove({ _id: id });
        }

        async useAccount(account) {
            await this.db_user.update(
                { _id: account._id },
                { $inc: { count: 1 } }
            );
            // await this.db_user.update({ _id: account._id }, { $set: { count: account.count + 1 } });
        }
    }

    //日志
    class Logger {
        constructor() {
            this.db_log = _global.db_log;
        }
        async addLog(platform, message) {
            // const doc = {
            //     create_time: dayjs().format('MM-DD HH:mm:ss.SSS'),
            //     platform: platform,
            //     message: message,
            // };
            // console.log(`[${doc.create_time}] [${platform}] ${message}`);
            // await this.db_log.insert(doc);
            let platform_display = platform ? ` [${platform}]` : '';
            let log_message = `[${dayjs().format('MM-DD HH:mm:ss')}]${platform_display} ${message}`;
            console.log(log_message);
            mainWindow.webContents.send('message', log_message);
        }
        async getLogs() {
            // console.log('获取日志', dayjs().format('HH:mm:ss'))
            return await this.db_log.find({}).sort({ create_time: -1 }).limit(50);
        }

        async clearLogs() {
            const todayStart = dayjs().startOf('day').format('MM-DD HH:mm:ss.SSS');
            return await this.db_log.remove({ create_time: { $lt: todayStart } }, { multi: true });
        }
    }

    //授权方法
    class Auth {
        async authAccount(model) {
            let win;
            try {
                let userDataDir = path.join(data_dir, 'session', `${model.platform}_${model.phone}`);
                win = new BrowserWindow({
                    width: 1280,
                    height: 720,
                    webPreferences: {
                        nodeIntegration: true,
                        contextIsolation: false,
                        webSecurity: true,
                        session: session.fromPath(userDataDir),
                    },
                    autoHideMenuBar: true,
                    title: "158GEO排名",
                    parent: BrowserWindow.getFocusedWindow(),
                    modal: true,

                });
                win.webContents.setUserAgent(user_agent);
                let page = await pie.getPage(browser, win);
                page.setDefaultTimeout(60000);
                switch (model.platform) {
                    case 'douyin':
                        await win.loadURL('https://www.douyin.com/aisearch', { waitUntil: 'networkidle2' });
                        await page.waitForSelector('[data-e2e="live-avatar"]');
                        break;
                    case 'doubao':
                        await win.loadURL('https://www.doubao.com/chat/?from_login=1', { waitUntil: 'networkidle2' });
                        await Promise.any([
                            page.waitForNavigation(),
                            page.waitForSelector('.flex.items-center.min-w-0.cursor-pointer.w-full')
                        ]);

                        await page.waitForSelector('.flex.items-center.min-w-0.cursor-pointer.w-full');
                        break;
                    case 'deepseek':
                        await win.loadURL('https://chat.deepseek.com/', { waitUntil: 'networkidle2' });
                        await page.waitForSelector('.ds-scroll-area');
                        break;
                    case 'qianwen':
                        await win.loadURL('https://www.qianwen.com/chat', { waitUntil: 'networkidle2' });
                        await page.waitForSelector('.tongyiDI-view-container img.rounded-full');
                        break;
                    case 'baidu':
                        await win.loadURL('https://chat.baidu.com/', { waitUntil: 'networkidle2' });
                        await page.waitForSelector('.chat-aside-user-mask:not(.unlogin)');
                        break;
                    default:
                        break;
                }
                //授权成功，更新授权状态
                await new DB().updateAccount(model._id, { auth: true, auth_time: dayjs().format('YYYY-MM-DD HH:mm:ss') });
                console.log('授权成功');
                return { success: true }
            } catch (e) {
                console.error('授权过程中发生错误:', e);
                return { success: false, message: e.message }
            } finally {
                if (win) {
                    win.close();
                }
            }
        }

    }

    class Api {
        //获取任务
        async getTask(platform) {
            // let str = `{"id":8459298,"status":1,"createdat":"2026-04-28T14:35:43.3964996+08:00","processing_started_at":"2026-04-28T14:35:43","trycount":0,"maxtries":3,"errors":"","payload":"{\\"id\\":33106,\\"keyname\\":\\"镇江不锈钢水箱源头厂家\\",\\"ainame\\":\\"苏州正大宏业不锈钢制品有限公司\\",\\"ainame_abbr\\":[\\"正大宏业\\",\\"镇江\\"],\\"ainame_not\\":null}","key":"33106","name":"douyinrank","task_name":""} `
            // let res = { data: JSON.parse(str) };
            // let payload = JSON.parse(res.data.payload);
            // let model = { id: payload.id, task_id: res.data.id, queuename: res.data.name, keyname: payload.keyname, ainame: payload.ainame, ainame_abbr: payload.ainame_abbr, isdabiao: false, screenshot: "", ainame_not: payload.ainame_not }
            // console.log(`获取任务${JSON.stringify(model)}`);
            // return model;

            let model = null;
            let url = `${queue_api}/queue/get?name=${platform}rank&taskname=${_global.customer ?? ""}`;
            await axios.get(url).then(async res => {
                if (res.data.id > 0) {
                    let payload = JSON.parse(res.data.payload);
                    model = { id: payload.id, task_id: res.data.id, queuename: res.data.name, keyname: payload.keyname, ainame: payload.ainame, ainame_abbr: payload.ainame_abbr, isdabiao: false, screenshot: "", ainame_not: payload.ainame_not }
                    console.log(`获取任务${JSON.stringify(model)}`);
                }
            }).catch(async error => {
                console.log(`获取任务失败${error.message}`);
            })
            return model;
        }

        //提交任务
        async post_task(platform, model) {
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${queue_api}/keyrank/set_aiseo`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(model)
            };
            console.log(`提交任务${JSON.stringify(model)}`);
            await axios.request(config)
                .then(async (response) => {
                    console.log(`提交任务返回: ${JSON.stringify(response.data)}`);
                })
                .catch(async (error) => {
                    console.log(`提交任务错误：${error.message}`);
                });
        }

        //插队
        async chaDui(customer) {
            let model = {};
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${main_api}/tools/chadui_geo?customer_name=${customer}&is_fore=false&sig=syo158tools_lx_856`,
            };

            await axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    model = response.data;
                    console.log(`插队返回: ${JSON.stringify(response.data)}`);
                })
                .catch((error) => {
                    console.log(error);
                });
            return model;
        }

        //上传图片
        async Upload(file_path) {
            let file_url = "";
            let data = new FormData();
            data.append('project', 'syo158_main');
            data.append('dir', 'dy_ai');
            data.append('file', await fs.createReadStream(file_path));
            let upload_url = `${file_api}/file/upload2?userid=-2`;

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: upload_url,
                data: data
            };
            await axios.request(config)
                .then(async (response) => {
                    if (!response.data.error) {
                        file_url = response.data.file_url;
                    } else {
                        console.log('上传图片错误' + response.data.error)
                    }
                }).catch(error => {
                    console.log('上传图片错误' + error)
                });
            return file_url;
        }
    }

    //执行任务
    class Task {
        constructor() {
            this.db_user = new DB();
            this.Logger = new Logger();
            this.api = new Api();
            if (_global.winChild) {
                _global.winChild.close();
                _global.winChild = null;
                _global.pageChild = null;
            }
        }

        //延时
        async delay(timeout) {
            await new Promise((resolve) => setTimeout(resolve, timeout));
        }

        //开启任务
        async startTask(model) {
            _global.customer = model.customer;
            _global.showChild = model.showChild;
            if (_global.customer) {
                console.log(_global.customer)
                let result = await this.api.chaDui(_global.customer);
                if (result?.code != 200) {
                    return { success: false, msg: result.msg };
                }
            }
            _global.is_running = true;
            this.startTaskAsync();
            return { success: true };
        }

        async startTaskAsync() {
            await this.Logger.addLog(null, '===== START =====');
            let number = 6;//账号每轮执行的任务数量
            while (_global.is_running) {
                await this.openWindow('douyin', number)
                await this.openWindow('doubao', number)
                await this.openWindow('deepseek', number)
                await this.openWindow('qianwen', number)
                await this.openWindow('baidu', number)
            }
            await this.stopTask();
            await this.Logger.addLog(null, '===== END =====');
            await this.closeWindow();
        }

        //停止任务
        async stopTask() {
            _global.is_running = false;
            return;
        }

        //打开窗口
        async openWindow(platform, number = 6) {
            if (_global.is_running == false) return;
            await this.Logger.addLog(platform, '->START');
            try {
                //获取账号
                let account = null;
                switch (platform) {
                    case 'douyin':
                        _global.accountDouyin = await this.db_user.getAuthAccount(platform, _global.accountDouyin);
                        account = _global.accountDouyin;
                        break;
                    case 'doubao':
                        _global.accountDoubao = await this.db_user.getAuthAccount(platform, _global.accountDoubao);
                        account = _global.accountDoubao;
                        break;
                    case 'deepseek':
                        _global.accountDeepseek = await this.db_user.getAuthAccount(platform, _global.accountDeepseek);
                        account = _global.accountDeepseek;
                        break;
                    case 'qianwen':
                        _global.accountQianwen = await this.db_user.getAuthAccount(platform, _global.accountQianwen);
                        account = _global.accountQianwen;
                        break;
                    case 'baidu':
                        _global.accountBaidu = await this.db_user.getAuthAccount(platform, _global.accountBaidu);
                        account = _global.accountBaidu;
                        break;
                    default:
                        break;
                }
                if (account == null) {
                    await this.Logger.addLog(platform, `没有可以用的账号`);
                    return;
                }
                //打开窗口
                let userDataDir = path.join(data_dir, 'session', `${account.platform}_${account.phone}`);
                _global.winChild = new BrowserWindow({
                    x: _global.showChild ? undefined : 9999,
                    y: _global.showChild ? undefined : 9999,
                    width: 1600,
                    height: 800,
                    skipTaskbar: _global.showChild ? false : true,
                    minimizable: false,
                    maximizable: false,
                    webPreferences: {
                        nodeIntegration: false,
                        contextIsolation: false,
                        webSecurity: false,
                        allowRunningInsecureContent: true,
                        session: session.fromPath(userDataDir),
                        backgroundThrottling: false,
                    },
                    autoHideMenuBar: true,
                    title: "158GEO排名",
                });
                _global.winChild.on('closed', async () => {
                    await this.closeWindow();
                });
                _global.winChild.webContents.setUserAgent(user_agent);
                _global.pageChild = await pie.getPage(browser, _global.winChild);
                _global.pageChild.setDefaultTimeout(1000 * 60);//通用等待时间60s

                //循环取任务
                for (let i = 0; i < number; i++) {
                    let model = await this.api.getTask(platform);
                    if (model == null) {
                        await this.Logger.addLog(platform, `没有任务，结束`);
                        return;
                    }
                    if (_global.is_running == false) {
                        await this.Logger.addLog(platform, `任务被停止，结束`);
                        return;
                    }
                    await this.Logger.addLog(platform, `获取任务，关键词[${model.keyname}]，目标词[${model.ainame ?? ""}]，简称[${model.ainame_abbr ?? ""}], 排除词[${model.ainame_not ?? ""}]`);
                    let result = null;
                    switch (platform) {
                        case 'douyin':
                            result = await this.searchDouyin(model);
                            break;
                        case 'doubao':
                            result = await this.searchDoubao(model);
                            break;
                        case 'deepseek':
                            result = await this.searchDeepseek(model);
                            break;
                        case 'qianwen':
                            result = await this.searchQianwen(model);
                            break;
                        case 'baidu':
                            result = await this.searchBaidu(model);
                            break;

                    }
                    if (result.msg) {
                        await this.Logger.addLog(platform, `任务执行失败，${result.msg}`);
                    } else {
                        //上报结果
                        await this.api.post_task(platform, result);
                        await this.db_user.useAccount(account);
                    }
                    await this.delay(10000);//循环间隔
                }
            } catch (e) {
                if (e.message.includes('Target closed') || e.message.includes('Attempted to use detached Frame ') || e.message.includes('page has been closed')) {
                    await this.Logger.addLog(platform, '浏览器被关闭');
                } else {
                    await this.Logger.addLog(platform, '执行过程错误 ' + e.message);
                }

            } finally {
                console.log('任务结束，清理环境');
                await this.closeWindow();
                await this.Logger.addLog(platform, '->END');
                await this.delay(1000 * 3);//结束后等待3秒再执行下一个任务，确保环境完全清理干净
            }
        }

        //关闭窗口
        async closeWindow() {
            if (_global.winChild) {
                console.log('关闭子窗口');
                if (_global.winChild && !_global.winChild.isDestroyed()) {
                    _global.winChild.close();
                }
                _global.winChild = null;
            }
        }

        //展示或隐藏子窗口
        async changeShowChild(show) {
            _global.showChild = show;
            if (_global.winChild) {
                if (show) {
                    _global.winChild.center();
                } else {
                    _global.winChild.setPosition(9999, 9999);
                }
            }
            return;
        }

        //抖音搜索
        async searchDouyin(model) {
            let platform = 'douyin';
            let locator = null;
            let text = "";

            //打开页面
            if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
            await _global.pageChild.setViewport({
                width: 1600,
                height: 800,
            });
            await _global.winChild.loadURL('https://www.douyin.com/aisearch', { waitUntil: 'networkidle2' });

            //检查授权
            let auth_result = true;
            await _global.pageChild.waitForSelector('[data-e2e="live-avatar"]', { timeout: 5000 }).catch(async e => {
                auth_result = false;
            })
            if (!auth_result) {
                await this.db_user.layoutAccounts(_global.accountDouyin);//登出账号
                // await this.Logger.addLog(platform, `账号 ${_global.accountDouyin.phone} 授权失效`);
                model.msg = "未授权";
                return model;
            }

            //等待页面加载完成
            await _global.pageChild.waitForSelector('div[id^="douyin-header-menu"]');

            // 等待AI模块加载
            let try_count = 0;
            while (_global.pageChild.frames().length < 2 && try_count < 10) {
                try_count++;
                await this.delay(1000 * 10);
            }
            if (try_count >= 10) {
                model.msg = "AI模块加载超时";
                return model;
            }
            let iframe = _global.pageChild.frames()[1];

            //输入关键词
            locator = await iframe.waitForSelector('div[class^="wellcome_"]');
            await locator.click();
            locator = await iframe.waitForSelector('#input_ai_search');
            await locator.type(model.keyname, { delay: 100 });
            await this.delay(2000);
            locator = await iframe.waitForSelector('div[class*="searchButtonActive_"]');
            await locator.click();
            await this.delay(2000);

            //检查是否有红色感叹号，出现就提醒
            locator = await iframe.$('div[class^="red_dot_container_"]');
            if (locator) {
                _global.winChild.center();
                await this.Logger.addLog(platform, `账号${_global.accountDouyin.phone} 出现安全验证，请手动完成验证`);

            }
            for (let index = 0; index < 30; index++) {
                locator = await iframe.$('div[class^="red_dot_container_"]');
                if (locator == null) {
                    break;
                } else {
                    await this.delay(1000 * 10);
                }
            }
            if (locator) {
                model.msg = "验证码无人操作";
                await this.Logger.addLog(platform, `账号${_global.accountDouyin.phone} 验证码无人操作"`);
                return model;
            } else {
                if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
            }

            //等待结果
            locator = await iframe.waitForSelector('x-view[data-button="search_repeat_answer"]', { timeout: 1000 * 60 * 2 });
            locator = await iframe.waitForSelector('#search-ai-outer-container');
            text = await locator.evaluate(x => x.innerText);
            if (text.includes('很抱歉，我还在努力学习中') || text.includes('当前人数过多，请稍后重试') || text.includes('当前高峰期使用人数过多')) {
                await this.Logger.addLog(platform, `账号${_global.accountDouyin.phone} 搜索失败，${text}`);
                model.msg = text;
                return model;
            }

            let height = await iframe.evaluate(() => {
                return document.querySelector("#scrollContainer").scrollHeight;
            })
            let res = await this.find_kw(text, model, platform, height);
            return res;
        }

        //豆包搜索
        async searchDoubao(model) {
            let platform = 'doubao';
            let locator = null;
            let text = "";

            //打开页面
            if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
            await _global.pageChild.setViewport({
                width: 1600,
                height: 800,
            });

            await _global.winChild.loadURL('https://www.doubao.com/', { waitUntil: 'networkidle2' });

            //等待页面加载完成
            await _global.pageChild.waitForSelector('p[data-placeholder="发消息或按住空格说话..."], p[data-placeholder="发消息..."]');

            //检查授权
            let auth_result = true;
            await _global.pageChild.waitForSelector('.flex.items-center.min-w-0.cursor-pointer.w-full', { timeout: 5000 }).catch(async e => {
                auth_result = false;
            })
            if (!auth_result) {
                await this.db_user.layoutAccounts(_global.accountDoubao);//登出账号
                // await this.Logger.addLog(platform, `账号 ${_global.accountDoubao.phone} 授权失效`);
                model.msg = "未授权";
                return model;
            }

            //输入关键词
            locator = await _global.pageChild.waitForSelector('p[data-placeholder="发消息或按住空格说话..."]');
            await locator.click();
            await this.delay(2000);
            await locator.type(model.keyname, { delay: 100 });
            await this.delay(2000);
            locator = await _global.pageChild.waitForSelector('.send-btn-wrapper.group');
            await locator.click();
            await this.delay(2000);

            //检查是否有验证码，出现就提醒
            let captch_div = `#captcha_container:not([style*="display: none"])`
            locator = await _global.pageChild.$(captch_div);
            if (locator) {
                _global.winChild.center();
                await this.Logger.addLog(platform, `账号${_global.accountDoubao.phone} 出现安全验证，请手动完成验证`);
            }
            for (let index = 0; index < 30; index++) {
                locator = await _global.pageChild.$(captch_div);
                if (locator == null) {
                    break;
                } else {
                    await this.delay(1000 * 10);
                }
            }
            if (locator) {
                model.msg = "验证码无人操作";
                await this.Logger.addLog(platform, `账号${_global.accountDoubao.phone} 验证码无人操作"`);
                return model;
            } else {
                if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
            }

            //等待结果
            locator = await _global.pageChild.waitForSelector('.message-action-bar-raqbg0 button[aria-haspopup="menu"]');
            await this.delay(2000);
            locator = await _global.pageChild.waitForSelector('div[data-copy-telemetry="right_click_copy"] .w-full');
            text = await locator.evaluate(x => x.innerText);

            let height = await _global.pageChild.evaluate(() => {
                return document.querySelector('div[class^="scrollable-"], .scroller.v_list_scroller-BxcoIX').scrollHeight;
            })
            let res = await this.find_kw(text, model, platform, height);
            return res;
        }

        //deepseek搜索
        async searchDeepseek(model) {
            let platform = 'deepseek';
            let locator = null;
            let text = "";
            //打开页面
            if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
            await _global.pageChild.setViewport({
                width: 1600,
                height: 800,
            });
            await _global.winChild.loadURL('https://chat.deepseek.com/', { waitUntil: 'networkidle2' });

            //判断授权
            if (_global.pageChild.url().includes('https://chat.deepseek.com/sign_in')) {
                await this.db_user.layoutAccounts(_global.accountDeepseek);//登出账号
                model.msg = "未授权";
                return model;
            }

            //禁言判断
            locator = await _global.pageChild.$('.ds-alert.ds-alert--warning.ds-alert--bordered .ds-alert__content');
            if (locator) {
                model.msg = '账号被禁言';
                await this.db_user.layoutAccounts(_global.accountDeepseek);//登出账号 
                await this.Logger.addLog(platform, `账号 ${_global.accountDeepseek.phone} 被禁言`);
                return model;
            }

            //输入关键词
            locator = await _global.pageChild.waitForSelector('textarea.ds-scroll-area');
            await locator.type(model.keyname, { delay: 100 });
            await this.delay(2000);
            locator = await _global.pageChild.waitForSelector('.ds-button.ds-button--primary');
            await locator.click();
            await this.delay(2000);

            //获取结果
            await _global.pageChild.waitForSelector('.ds-scroll-area.ds-scroll-area .ds-flex .ds-flex')
            locator = await _global.pageChild.waitForSelector('.ds-markdown');
            text = await locator.evaluate(x => x.innerText);

            let height = await _global.pageChild.evaluate(() => {
                return document.querySelector('.ds-virtual-list.ds-virtual-list--printable').scrollHeight;
            })
            let res = await this.find_kw(text, model, platform, height);
            return res;
        }

        //千问搜索
        async searchQianwen(model) {
            let platform = 'qianwen';
            let locator = null;
            let text = "";

            //打开页面
            if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
            await _global.pageChild.setViewport({
                width: 1600,
                height: 800,
            });
            await _global.winChild.loadURL('https://www.qianwen.com/chat', { waitUntil: 'networkidle2' });

            //等待页面加载完成
            locator = await _global.pageChild.waitForSelector('.tongyiDI-view-container.text-area-slot-container');

            //检查授权
            locator = await _global.pageChild.waitForSelector('.tongyiDI-view-container img.rounded-full');
            if (locator == null) {
                await this.db_user.layoutAccounts(_global.accountQianwen);//登出账号
                model.msg = "未授权";
                return model;
            }

            //输入关键词
            locator = await _global.pageChild.waitForSelector('.tongyiDI-view-container.text-area-slot-container');
            await locator.type(model.keyname)
            await this.delay(2000);
            locator = await _global.pageChild.waitForSelector('button[aria-label="发送消息"]');
            await locator.click();
            await this.delay(2000);

            //获取结果
            await _global.pageChild.waitForSelector('.mt-4');
            await this.delay(5000);//长文显示完整有延迟
            locator = await _global.pageChild.waitForSelector('.message-list-scroll-container .markdown-pc-special-class');
            text = await locator.evaluate(x => x.innerText);

            let height = await _global.pageChild.evaluate(() => {
                return document.querySelector('.message-list-scroll-container').scrollHeight;
            })
            let res = await this.find_kw(text, model, platform, height);
            return res;
        }

        //百度搜索
        async searchBaidu(model) {
            let platform = 'baidu';
            let locator = null;
            let text = "";
            let answer = "";
            let height = 0;
            //打开页面
            if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
            await _global.pageChild.setViewport({
                width: 1600,
                height: 800,
            });
            await _global.winChild.loadURL('https://baidu.com', { waitUntil: 'networkidle2' });

            //检查授权
            locator = await _global.pageChild.waitForSelector('.user-name');
            if (locator == null) {
                await this.db_user.layoutAccounts(_global.accountBaidu);//登出账号
                model.msg = "未授权";
                return model;
            }
            await this.delay(5000);
            const aiSelector = 'div[tpl="new_baikan_index"],div[tpl="wenda_generate"]';
            //输入关键词
            let search_type = 1;
            locator = await _global.pageChild.waitForSelector('#chat-textarea');
            await locator.type(model.keyname, { delay: 100 });
            await this.delay(2000);
            locator = await _global.pageChild.waitForSelector('#chat-submit-button');
            await locator.click();
            await this.delay(2000);

            //首页AI图标
            locator = await _global.pageChild.$(aiSelector);
            if (locator) {
                let locator_height = await _global.pageChild.evaluate((selector) => {
                    return document.querySelector(selector).scrollHeight;
                }, aiSelector)
                if (Number(locator_height) == 0) {
                    search_type = 2;
                    console.log('AI结果被隐藏，切换搜索类型');
                } else {
                    console.log('AI结果正常显示，继续');
                    try {
                        //直接获取到AI结果
                        await _global.pageChild.waitForSelector('div[class^="share-container_"]');
                        let zhankai = await _global.pageChild.$('div.cos-fold-switch-context');//展开
                        if (zhankai) {
                            await zhankai.click();
                            await this.delay(1000);
                        }
                        //
                        //获取结果
                        locator = await _global.pageChild.waitForSelector(aiSelector);
                        answer = await locator.evaluate(x => x.innerText);
                        answer = answer.replace(/\n/g, '');
                        locator_height = await _global.pageChild.evaluate((selector) => {
                            return document.querySelector(selector).scrollHeight;
                        }, aiSelector)
                        if (Number(locator_height) == 0) {
                            search_type = 2;
                            console.log('AI结果展开后被隐藏，切换搜索类型');
                        } else {
                            height = await _global.pageChild.evaluate(() => {
                                return document.querySelector('body').scrollHeight - 300;
                            })
                            console.log('AI结果正常显示，获取截屏高度:' + height);
                            //如果没达标也进文心一言
                            if (this.is_in(answer, model.ainame) == null && this.is_in(answer, model.ainame_abbr) == null) {
                                search_type = 2;
                                console.log('AI结果未达标，切换搜索类型');
                            } else {
                                console.log('AI结果达标，继续');
                            }
                        }
                    } catch (error) {
                        search_type = 2;
                        console.log('AI结果获取失败，切换搜索类型', error.toString());
                    }
                }
            } else {
                search_type = 2;
                console.log('未获取到AI结果，切换搜索类型');

                //检查是否有验证码，出现就提醒
                let is_captcha = await this.baiduCapture()
                if (is_captcha) {
                    model.msg = "验证码无人操作";
                    await this.Logger.addLog(platform, `账号${_global.accountBaidu.phone} 验证码无人操作"`);
                    return model;
                } else {
                    if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
                }
            }

            //打开文心一言
            if (search_type == 2) {
                console.log('进入文心一言搜索');
                await this.delay(2000);
                //没有直接结果点击AI图标
                locator = await _global.pageChild.$('a[href^="https://chat.baidu.com/search?word="]')
                if (locator) {
                    await locator.click();
                    await _global.pageChild.waitForNavigation();
                } else {
                    //没有AI图标就跳转
                    await _global.pageChild.goto('https://chat.baidu.com/search', { waitUntil: 'networkidle2' });
                    //输入关键词
                    locator = await _global.pageChild.waitForSelector('#chat-textarea');
                    await locator.type(model.keyname)
                    await this.delay(2000);
                    locator = await _global.pageChild.waitForSelector('span.ci-submit-button');
                    await locator.click();
                    await this.delay(2000);
                }

                //检查是否有验证码，出现就提醒
                let is_captcha = await this.baiduCapture()
                if (is_captcha) {
                    model.msg = "验证码无人操作";
                    await this.Logger.addLog(platform, `账号${_global.accountBaidu.phone} 验证码无人操作"`);
                    return model;
                } else {
                    if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
                }

                //获取结果
                await this.delay(2000);
                await _global.pageChild.waitForSelector('.cos-icon.cos-icon-share1');
                locator = await _global.pageChild.$('.ai-entry .ai-markdown');
                answer = await locator.evaluate(x => x.innerText);
                answer = answer.replace(/\n/g, '');

                //隐藏右侧栏
                locator = await _global.pageChild.$('div[class^="_close-collapse-btn"]');
                if (locator) {
                    await locator.click();
                    await this.delay(1000);
                }
                height = await _global.pageChild.evaluate(() => {
                    return document.querySelector('.chat-qa-container').scrollHeight;
                })

            }

            let res = await this.find_kw(answer, model, platform, height);
            return res;
        }

        //百度验证码
        async baiduCapture() {
            //检查是否有验证码，出现就提醒
            let is_captcha = (await _global.pageChild.url()).includes('captcha');
            if (is_captcha) {
                _global.winChild.center();
                await this.Logger.addLog('baidu', `账号${_global.accountBaidu.phone} 出现安全验证，请手动完成验证`);
            }
            else {
                if (!_global.showChild) _global.winChild.setPosition(9999, 9999);
            }
            for (let index = 0; index < 30; index++) {
                is_captcha = (await _global.pageChild.url()).includes('captcha');
                if (!is_captcha) {
                    break;
                } else {
                    await this.delay(1000 * 10);
                }
            }
            return is_captcha;
        }

        //检测目标词
        async find_kw(text, model, platform, height) {
            if (model.ainame_not && model.ainame_not != '') {
                let reg = new RegExp(model.ainame_not, 'g');
                text = text.replace(reg, '**');
            }
            text = text.replace(/\n/g, '');
            console.log(text);//记录
            let target = this.is_in(text, model.ainame);
            if (target == null) { target = this.is_in(text, model.ainame_abbr); }
            if (target) {
                try {
                    //查找标记
                    console.log(`找到目标词[${target}]，正在标记并滚动到可视区域`);
                    const found = await _global.pageChild.evaluate((kw) => {
                        let result = window.find(kw, false, false, true, false, true, false);
                        if (result) {
                            const sel = window.getSelection();
                            if (sel && sel.rangeCount > 0) {
                                const range = sel.getRangeAt(0);
                                const highlight = document.createElement('span');
                                highlight.style.cssText = 'background-color: yellow !important; color: black !important; display: inline;';
                                range.surroundContents(highlight);
                                highlight.scrollIntoView({ block: 'center' });
                                sel.removeAllRanges();
                            }
                        }
                        return result;
                    }, target);
                    if (found) {
                        console.log(`找到目标词[${target}]，已标记并滚动到可视区域`);
                    }
                    await this.delay(1000);
                } catch (e) {
                    console.log(`标记目标词失败，继续截图`, e.toString());
                }
                //截图
                let page_height = 800;
                if (height + 300 > 800) {
                    page_height = height + 300;
                }
                await _global.pageChild.setViewport({
                    width: 1600,
                    height: page_height,
                });
                console.log(`内容高度${height}，设置页面高度${page_height}`);

                await this.delay(1000 * 2);
                const image = await _global.winChild.webContents.capturePage();
                const pngBuffer = image.toPNG();
                let savePath = path.join(_global.screenshotPath, `${model.id}.jpg`)
                fs.writeFileSync(savePath, pngBuffer);
                console.log(`[截图成功] 隐身窗口画面已保存至: ${savePath}`);
                let file_url = await this.api.Upload(savePath);

                await this.Logger.addLog(platform, `发现目标词[${target}]，已达标，截图已上传[${file_url}]`);
                if (file_url != "") {
                    model.isdabiao = true;
                    model.screenshot = file_url;
                } else {
                    model.isdabiao = false;
                    await this.Logger.addLog(platform, `截图上传失败`);
                }

            }
            else {
                model.isdabiao = false;
                await this.Logger.addLog(platform, `未发现目标词，未达标`);
            }
            return model;
        }


        //找目标词
        is_in(content, ainame) {
            //排除null
            if (ainame) {
                if (Array.isArray(ainame)) {
                    //排除[]
                    for (let index in ainame) {
                        if (ainame[index] == "") continue;//排除[""]
                        if (content.includes(ainame[index])) {
                            return ainame[index];
                        }
                    }
                } else {
                    //排除""
                    if (ainame == "") {
                        return null;
                    }
                    return content.includes(ainame) ? ainame : null;
                }
            }
            return null;
        }

    }

    //方法映射表
    const funcMap = {
        getAllAccounts: () => new DB().getAllAccounts(),
        addAccount: (model) => new DB().addAccount(model),
        updateAccount: (id, updates) => new DB().updateAccount(id, updates),
        deleteAccount: (id) => new DB().deleteAccount(id),
        getLogs: () => new Logger().getLogs(),
        authAccount: (model) => new Auth().authAccount(model),
        startTask: (model) => new Task().startTask(model),
        stopTask: () => new Task().stopTask(),
        clearLogs: () => new Logger().clearLogs(),
        changeShowChild: (show) => new Task().changeShowChild(show),
    };

    return await funcMap[func](model);
}
